import {
  Typography,
  ButtonBase as BaseButtonBase,
  styled,
  Box,
} from '@mui/material'
import { Filter } from 'shared/assets'

export const Icon = styled(Filter)(({ theme }) => ({
  stroke: 'inherit',
  marginRight: theme.spacing(0.75),
  width: 11,
  height: 11,
  transform: 'translateY(-10%)',
  color: theme.palette.primary.main,
}))

export const ButtonBase = styled(BaseButtonBase)(() => ({
  padding: 6,
}))

export const FilterTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 12,
  lineHeight: '14px',
}))

export const DataGridContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isLoading' && prop !== 'isMobile',
})<{
  isLoading?: boolean
  isMobile?: boolean
}>(({ theme, isLoading, isMobile }) => ({
  width: 500,
  height: 700,
  ...(isMobile && {
    maxHeight: 'min(700px, calc(100dvh - 24px))',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    touchAction: 'pan-x pan-y',
  }),
  '& .MuiDataGrid-virtualScroller': {
    ...(isMobile && {
      overflow: 'auto !important',
      WebkitOverflowScrolling: 'touch',
    }),
  },
  '& .MuiDataGrid-footerContainer': {
    minHeight: 52,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
    overflow: 'hidden',
  },
  '& .MuiDataGrid-selectedRowCount': {
    margin: 0,
    marginRight: theme.spacing(1),
    fontSize: '0.8125rem',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    visibility: 'visible',
    width: 'auto',
    height: 'auto',
  },
  '& .MuiTablePagination-root': {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
  },
  '& .MuiTablePagination-toolbar': {
    minHeight: 52,
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    gap: theme.spacing(0.5),
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
  },
  '& .MuiTablePagination-spacer': {
    flex: '0 0 0',
    width: 0,
  },
  '& .MuiTablePagination-selectLabel': {
    margin: 0,
    fontSize: '0.8125rem',
    whiteSpace: 'nowrap',
  },
  '& .MuiTablePagination-select': {
    marginRight: theme.spacing(0.75),
    fontSize: '0.8125rem',
  },
  '& .MuiTablePagination-input': {
    marginRight: theme.spacing(0.5),
  },
  '& .MuiTablePagination-displayedRows': {
    margin: 0,
    fontSize: '0.8125rem',
    whiteSpace: 'nowrap',
  },
  '& .MuiTablePagination-actions': {
    marginLeft: theme.spacing(0.5),
  },
  '& .MuiTablePagination-actions .MuiIconButton-root': {
    padding: theme.spacing(0.75),
  },
  ...(isLoading && {
    '& .MuiTablePagination-root .MuiIconButton-root': {
      color: theme.palette.action.disabled,
      pointerEvents: 'none',
    },
    '& .MuiTablePagination-toolbar .MuiTablePagination-selectLabel, & .MuiTablePagination-toolbar .MuiTablePagination-displayedRows':
      {
        color: theme.palette.text.secondary,
      },
    '& .MuiTablePagination-toolbar .MuiInputBase-root': {
      color: theme.palette.action.disabled,
      pointerEvents: 'none',
    },
    '& .MuiTablePagination-toolbar .MuiSelect-select': {
      color: theme.palette.action.disabled,
      pointerEvents: 'none',
    },
    '& .MuiTablePagination-toolbar .MuiSvgIcon-root': {
      color: theme.palette.action.disabled,
      pointerEvents: 'none',
    },
  }),
}))
